export default __webpack_public_path__ + "static/hq13-d7263f1d0d7d25057a1bd0ba4d28bbed.jpg";